import { drawVectorStyle, loadVectorStyle } from "./world-map-vector-style";
import { TILE_SIZE_PX, WorldMapStyle } from "./world-map-tiles";

// The basemaps of the Dashboard map: "OpenStreetMap Topographic (for 3D)" and imagery with the "Hybrid Reference Layer"
const MAP_STYLE_URL =
  "https://www.arcgis.com/sharing/rest/content/items/1e7d1784d1ef4b79ba6764d0bd6c3150/resources/styles/root.json";
const HYBRID_STYLE_URL =
  "https://cdn.arcgis.com/sharing/rest/content/items/30d6b8271e1849cd9c3042060001f425/resources/styles/root.json";

function imageryUrl(z: number, x: number, y: number): string {
  return `https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/${z}/${y}/${x}`;
}

function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Failed to load ${url}`));
    image.src = url;
  });
}

/**
 * @param style The basemap to draw
 * @param tile The Web Mercator tile to draw
 * @param tile.z Zoom level
 * @param tile.x Tile column
 * @param tile.y Tile row
 * @returns A canvas with the tile, styled like the Dashboard map
 */
export async function renderBasemapTile(
  style: WorldMapStyle,
  tile: { z: number; x: number; y: number },
): Promise<HTMLCanvasElement> {
  const canvas = document.createElement("canvas");
  canvas.width = TILE_SIZE_PX;
  canvas.height = TILE_SIZE_PX;

  if (style === WorldMapStyle.map) {
    await drawVectorStyle(await loadVectorStyle(MAP_STYLE_URL), tile, canvas);
    return canvas;
  }

  const [image, roads] = await Promise.all([
    loadImage(imageryUrl(tile.z, tile.x, tile.y)),
    // The roads overlay is optional, the imagery is shown without it
    loadVectorStyle(HYBRID_STYLE_URL).catch(() => undefined),
  ]);
  canvas.getContext("2d")?.drawImage(image, 0, 0, TILE_SIZE_PX, TILE_SIZE_PX);
  if (roads) await drawVectorStyle(roads, tile, canvas).catch(() => undefined);
  return canvas;
}
